<div class="stories">
  <a
    class="stories__item"
    *ngFor="let user of storiesAvatars"
    [routerLink]="['/@' + user.username, 'stories']"
    [style.maxWidth]="(avatarSize + 10) + 'px'"
    [style.minWidth]="(avatarSize + 10) + 'px'"
    [matTooltip]="'@'+ user.username"
    [mipGoBackReferrer]
  >

    <mip-avatar
      class="stories__avatar"
      mip-avatar
      [userModel]="user"
      [size]="avatarSize"
      borderColor="primary"
    ></mip-avatar>

    <small class="stories__name">
      {{ user.getName() || '@' + user.username }}
    </small>

  </a>
</div>
